export const ROLE = ['ADMIN','GOPHER','REQUESTER']